import { FiscalReceipts } from './FiscalReceipts';

/** Fiscal receipt list — real table + retry/pdf actions (Task 14). */
export function FiscalReceiptsPage() {
  return <FiscalReceipts />;
}
